import { ESort } from '../../repositories/newbuilding-reviews/entities/get_questions_web/GetQuestionsWebRequest';
import { ESortType } from '../../types/sort';

const mapper = {
  [ESortType.By_date_asc]: ESort.By_date_asc,
  [ESortType.By_date_desc]: ESort.By_date_desc,
  [ESortType.By_rating_asc]: ESort.Default,
  [ESortType.By_rating_desc]: ESort.Default,
  [ESortType.Default]: ESort.Default,
};

export const prepareQuestionSortRequest = (sort?: ESortType | null): ESort | null => {
  return sort ? mapper[sort] : null;
};
